// extracted by mini-css-extract-plugin
module.exports = {"table":"CatalogTable_table__1yxB6","title":"CatalogTable_title__3r9wl","gray":"CatalogTable_gray__34_Ir"};